
export class AppUtils {
	public static copyToClipboard(text: string): Promise<void> {
		return navigator.clipboard.writeText(text)
	}

	public static truncateString(text: string, length?: number): string {
		return length && length <= text.length ? `${text.substring(0, length)}...` : text
	}

	public static buildSearchParam(data: Record<string, string>): string {
		const params = new URLSearchParams();
		Object.keys(data).forEach((k) => {
			params.append(k, data[k])
		})
		return params.toString()
	}

	public static hidePasswordText(text: string): string {
		return new Array<string>(text.length).fill("#").join("")
	}

	public static capitalize(text: string): string {
		return text ? text.replace(/^\w/, (c) => c.toUpperCase()) : "";
	}


	public static generateId(): string {
		return `id${Math.random().toString(16).slice(2)}`
	}

	public static sortBy<T>(data: T[], key: keyof T, direction: 'asc' | 'desc' = 'desc', isUnicode = false): T[] {
		return data.sort((a, b) => {
			const itemA = isUnicode ? String(a[key]).toLowerCase() : a[key];
			const itemB = isUnicode ? String(b[key]).toLowerCase() : b[key];
			if (itemA > itemB) {
				return direction === 'asc' ? 1 : -1;
			} else if (itemA < itemB) {
				return direction === 'asc' ? -1 : 1;
			} else {
				return 0;
			}
		})
	}


	public static isValidURL(url: string): boolean {
		try {
			new URL(url);
		} catch (e) {
			return false;
		}
		return true;
	}

	public static numberToPrice(num: number): string {
		return `${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(num)}`
	}

	public static reorder = <T>(list: T[], sourceIndex: number, destIndex: number): T[] => {
		const result = Array.from(list)
		const [removed] = result.splice(sourceIndex, 1);
		result.splice(destIndex, 0, removed)
		return result
	}


	public static randomRgbColor(): [number, number, number] {
		const randomInteger = (max: number) => {
			return Math.floor(Math.random() * (max + 1));
		}
		const r = randomInteger(255);
		const g = randomInteger(255);
		const b = randomInteger(255);
		return [r, g, b];
	}

	public static randomHexColor(): string {
		const [r, g, b] = this.randomRgbColor();
		const hr = r.toString(16).padStart(2, '0');
		const hg = g.toString(16).padStart(2, '0');
		const hb = b.toString(16).padStart(2, '0');
		return "#" + hr + hg + hb;
	}


	public static compareObjects<T = unknown>(object1: T, object2: T): boolean {
		// eslint-disable-next-line  @typescript-eslint/no-explicit-any
		const keys1 = Object.keys(object1 as any ?? {}) as Array<keyof T>;
		// eslint-disable-next-line  @typescript-eslint/no-explicit-any
		const keys2 = Object.keys(object2 as any ?? {}) as Array<keyof T>;

		if (keys1.length !== keys2.length) {
			return false;
		}

		for (const key of keys1) {
			if (object1[key] !== object2[key]) {
				return false;
			}
		}

		return true;
	}


	public static pickObject<T, K extends keyof T>(object: T, keys: K[]): Pick<T, K> {
		return keys.reduce((obj, key) => {
			if (object && Object.prototype.hasOwnProperty.call(object, key)) {
				obj[key] = object[key]
			}
			return obj
		}, {} as Pick<T, K>)
	}
}
